import httpClient from "./httpClient";

export default {
  // Departure Guides
  async getGuides(departure) {
    const response = await httpClient.get(`/departures/${departure.id}/guides`);
    return response.data;
  },

  async assignGuide(departure, args) {
    const response = await httpClient.post(
      `/departures/${departure.id}/guides`,
      {
        ...args
      }
    );
    return response.data;
  },

  async removeGuide(departure, guide) {
    const response = await httpClient.delete(
      `/departures/${departure.id}/guides/${guide.id}`
    );
    return response.data;
  },

  // Departure Extra
  async getExtras(departure) {
    const response = await httpClient.get(`/departures/${departure.id}/extras`);
    return response.data;
  },

  async assignExtra(departure, args) {
    const response = await httpClient.post(
      `/departures/${departure.id}/extras`,
      {
        ...args
      }
    );
    return response.data;
  },

  async updateExtra(departure, extra) {
    const response = await httpClient.put(
      `/departures/${departure.id}/extras/${extra.id}`,
      {
        ...extra
      }
    );
    return response.data;
  },

  async removeExtra(departure, extra) {
    const response = await httpClient.delete(
      `/departures/${departure.id}/extras/${extra.id}`
    );
    return response.data;
  },

  async getDeparture(tourId, departureId) {
    const response = await httpClient.get(
      `tours/${tourId}/departures/${departureId}`
    );
    return response.data;
  },

  async getManifest(departureId) {
    const response = await httpClient.get(
      `/departures/${departureId}/manifest`
    );
    return response.data;
  },

  async getManifestItinerary(departureId) {
    const response = await httpClient.get(
      `/departures/${departureId}/manifest`
    );
    return response.data;
  },

  async updateManifest(departureId, manifest) {
    const response = await httpClient.post(
      `/departures/${departureId}/manifest`,
      {
        ...manifest
      }
    );
    return response.data;
  },

  async getManifestDefault(departureId, section) {
    const response = await httpClient.get(
      `/departures/${departureId}/manifest/${section}/default`,
      { errorHandle: false }
    );
    return response.data;
  },

  async saveManifestDefault(departureId, section, rows, replace) {
    const response = await httpClient.put(
      `/departures/${departureId}/manifest/${section}/default`,
      { rows, replace },
      { errorHandle: false }
    );
    return response.data;
  },

  async saveManifestSection(departureId, section, rows) {
    const response = await httpClient.put(
      `/departures/${departureId}/manifest/${section}`,
      { rows },
      { errorHandle: false }
    );
    return response.data;
  },

  async saveManifestText(departureId, section, value) {
    const response = await httpClient.put(
      `/departures/${departureId}/manifest/${section}/text`,
      { value },
      { errorHandle: false }
    );
    return response.data;
  },

  async downloadEmergencyCards(departureId) {
    const response = await httpClient.get(
      `/departures/${departureId}/emergency-cards/download`,
      { responseType: "blob", errorHandle: false }
    );
    return response.data;
  },

  async downloadManifest(departureId) {
    const response = await httpClient({
      url: `/departures/${departureId}/manifest/download`,
      method: "get",
      responseType: "blob"
    });
    return response.data;
  },

  async downloadAdventureBookings(departureId) {
    const response = await httpClient({
      url: `/departures/${departureId}/bookings/download`,
      method: "get",
      responseType: "blob"
    });
    return response.data;
  },

  async getUpcomingDepartures() {
    const response = await httpClient.get("/widgets/upcoming-departures");
    return response.data;
  },

  /* Departure Tickets */
  async getDepartureTickets(departureId) {
    const response = await httpClient.get(`/departures/${departureId}/tickets`);
    return response.data;
  },

  async getDepartureSummary(departureId) {
    const response = await httpClient.get(`/departures/${departureId}/summary`);
    return response.data;
  },

  async createDepartureTicket(ticket) {
    const response = await httpClient.post(
      `/departures/${ticket.departure_id}/tickets`,
      {
        ...ticket
      }
    );
    return response.data;
  },

  async updateDepartureTicket(ticket) {
    const response = await httpClient.put(
      `/departures/${ticket.departure_id}/tickets/${ticket.id}`,
      {
        ...ticket
      }
    );
    return response.data;
  },

  async deleteDepartureTicket(ticket) {
    const response = await httpClient.delete(
      `/departures/${ticket.departure_id}/tickets/${ticket.id}`
    );
    return response.data;
  }
};
